import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  list: [],
  metaData: [],
  dedications: [],
};

const EventSongListSlice = createSlice({
  name: "EventSongList",
  initialState,
  reducers: {
    eventSongListSuccess(state, action) {
      state.list = action.payload.list
      state.metaData = action.payload.metaData
      state.dedications = action.payload.dedications ?? []
    },
    eventSongListError(state, action) {
        state.error = action.payload
    },
    eventSongListDeleteSuccess(state) {
      state.list = []
      state.dedications = []
    },
  },
});

export const {
  eventSongListSuccess,
  eventSongListError,
  eventSongListDeleteSuccess
} = EventSongListSlice.actions

export default EventSongListSlice.reducer;
